// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YWbxR","maxWidthContainer":"styles_maxWidthContainer__gZ1MM"};